import { axiosObject } from "../config";

function getStates() {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/states/_read";
    let payload = {
      limitBy: {
        per_page: 10,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getAllStates() {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/states/_read";
    let payload = {
      limitBy: {
        per_page: 100,
        page: 1,
      },
      sortBy: [{ attribute: "created_at", order: "asc" }],
      filterBy: [],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getState(data: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/states/_read";
    let payload = {
      filterBy: [
        {
          attribute: "slug",
          op: "eq",
          value: data.slug,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { getStates, getState, getAllStates };
